export const MASTER_PAGE = 'masterPage'
export const SOSP_CONTAINER_CUSTOM_ID = 'SOSP_CONTAINER_CUSTOM_ID'
export const SOSP_MODE_TYPE = 'SHOW_ON_SOME_PAGES'
